import { closeCurrentWebView } from "@/utils/native/interaction";
import { getThemeBgColor } from "@/utils/project";
export default [
  {
    path: "/wt-annual-bill",
    name: "AnnualBill",
    meta: {
      title: "年度账单",
      // showHeader: true,
      keepAlive: true,
      background: "transparent"
    },
    component: () =>
      import(
        /* webpackChunkName: "star-level" */ "@/views/mine/annual-bill/AnnualBill.vue"
      )
  }
];
